import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerFunctionToggleFavouritePut = {
    path: "/template/content-blocker/functions/toggleFavourite",
    method: ERouteHttpVerb.PUT
};
export { routeLocationContentBlockerFunctionToggleFavouritePut };
